export default class LoadingListener {
    toListenFor = [];
    listenToAll = false;

    constructor(toListenFor, listenToAll = false) {
        this.toListenFor = toListenFor;
        this.listenToAll = listenToAll;
    }

    isLoading(loadingRequests) {
        const contains = (element) => this.listenToAll || this.toListenFor.includes(element);
        return loadingRequests.some(contains);
    }
}


// WEBPACK FOOTER //
// ./src/helpers/loadingListener.js